module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-wrap folder",
    class: {
      opened: _vm.opened
    }
  }, [_c('div', {
    staticClass: "file-row",
    on: {
      "dblclick": function($event) {
        _vm.opened = !_vm.opened
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "file-name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "file-btns"
  }, [_c('span', {
    ref: "deleteBtn",
    staticClass: "file-btn file-btn__delete",
    on: {
      "click": _vm.deleteFolder
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "folder-nested"
  }, [_vm._l((_vm.content.folders), function(folderContent, folderName) {
    return _c('SelectelFolder', {
      key: (_vm.name + "/" + folderName),
      attrs: {
        "name": folderName,
        "path": (_vm.path + "/" + folderName),
        "content": folderContent
      },
      on: {
        "folderDeleted": _vm.onFolderDeleted,
        "fileDeleted": _vm.onFileDeleted
      }
    })
  }), _vm._v(" "), _vm._l((_vm.content.files), function(file) {
    return _c('File', {
      key: file.basename,
      attrs: {
        "file": file
      },
      on: {
        "fileDeleted": _vm.onFileDeleted
      }
    })
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-type"
  }, [_c('i', {
    staticClass: "fa fa-folder"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-folder-open"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0af49112","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/publicFiles/Folder.vue
// module id = 815
// module chunks = 0